import { Confetti } from '@/widgets/confetti/ui';

import { withErrorBoundary } from '@/shared/hocs/withErrorBoundary';
import { useEnableClosingConfirmation } from '@/shared/hooks/telegram/use-enable-closing-confirmation';
import { useTelegramTheme } from '@/shared/hooks/telegram/use-telegram-theme';
import { useDevtoolsLocker } from '@/shared/hooks/use-devtools-locker';
import { useLockOrientation } from '@/shared/hooks/use-orientation/use-lock-orientation';
import { ProgressiveBlurTop } from '@/shared/ui/progressive-blur-header';

import { useLocaleListener } from '../hooks/use-locale-listener';
import { useScreenTimeTracking } from '../hooks/ws/use-screen-time-tracking';
import { useSessionTracking } from '../hooks/ws/use-session-tracking';
import { useWalletSubscription } from '../hooks/ws/use-wallet-subscription';
import { AppRouter } from '../providers/app-router';

import s from './app.module.scss';

export const App = withErrorBoundary(() => {
  useDevtoolsLocker();

  useTelegramTheme();
  useLockOrientation();
  useEnableClosingConfirmation();

  useLocaleListener();
  useWalletSubscription();

  useSessionTracking();
  useScreenTimeTracking();

  return (
    <div className={s.container}>
      <ProgressiveBlurTop />
      <AppRouter />
      <Confetti />
    </div>
  );
});
